var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.66,183.31A55.71,55.71,0,0,1,252,206.09c-6.45,12.14-3.41,35.11-.19,34S274.6,226,277.26,218.61s2.08-18.41,6.83-30.17S291.87,170,291.87,170,263.59,182.93,258.66,183.31Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271,101.89a48.37,48.37,0,0,0-16.51,18.6c-6.07,12.34-5.69,28.66-5.69,28.66s.57,18.22-.38,25.43,8,12.34,12.14,12.53,17.08-8.35,23.16-10.82,7.78-2.85,13.66-8.73,15.95-23.73,16.52-33.78S312.75,112,304,104.93,283.52,95.63,271,101.89Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.67,269.48s5.31,13.47,9.11,18,14,11.95,22.58,17.65,10.25,18.41,8.92,23.15-5.31,8.54-14.23,6.08-16.14-13.1-23.54-24.11-12.33-19.17-12.9-19.74S295.67,269.48,295.67,269.48Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.36,416s4.95,1.81,15.19-2.17c14.59-5.66,37.86-24.83,37.86-24.83a95.55,95.55,0,0,1-34,0c-18.81-3.38-28.93-8.44-28.93-8.44L271.7,408.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.76,365.87s7.9-1.27,3.56,10.55-18.51,22.24-20.2,30.68.24,8.92.24,8.92l-24.59-5.3s1.93-18.33,15.43-32.31S317.76,365.87,317.76,365.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.77,424s4.1-1,8.2-7,13.26-25.08,20.74-35.21,19.05-15.91,19.05-15.91l-58.6-6.51s-23.87,26.76-32.07,36.17-9.16,18.08-3.37,20.25,24.11,4.34,28.93,5.07S265.67,424.7,269.77,424Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.38,356s4.82,0,2.17,7.72-18.33,28-23.39,41.71S269.77,424,269.77,424s-1.93,2.89-30.14-3.13-46.29-6.76-48-11.58,9.4-17.84,13.5-28.21,14.47-34.72,14.47-34.72,41,8,49.67,8.68S287.38,356,287.38,356Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.75,386.6s0,1.93,7.24-6.75S287.38,356,287.38,356l-74.51-16.15S191.65,361.77,189,365.14s-4.59,4.34,2.41,7.48,42,7,49.43,8.92S256.75,386.6,256.75,386.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263s-1.66,5.43-4.07,23.52-6,38.82-10.85,54.25-14.23,37.86-14.95,40.75a5.94,5.94,0,0,0,1.2,5.06s-9.4-1.44-35.93-4.34-52.56-15.91-51.84-17.6,18.09-18.81,28-41,25.32-77.89,25.32-77.89,31.35,14.71,40.75,15.68S285.42,263,285.42,263Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-10--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263s-4.37,12.34-9.3,27.52a277.24,277.24,0,0,0-7.79,30.37s-3.41-1.9-28.84-10.63-57.32-19.36-57.32-19.36,23.91-28.09,29-41.56,7.78-11,19.55-6.45,28.09,12.9,37.57,13.85S285.42,261.13,285.42,263Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-11--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.37,189.2s1.14,19.35,1.14,20.11-31.32,33.41-38.53,41-7.4,13.85-5.7,18.6,7.6,11.58,12.91,12.33,11.2-4.55,16.51-16.32,24.3-47.26,26.38-51.05,7-7.21,7-7.21,5.12-2.66,7.4-6.46,6.64-11.38,11.38-15,7-4.56,4.94-5.69-8.73,1.32-10.63,2.65-6.07,4.75-6.07,4.75-3.61-5.32-3.8-9.87.95-11.06-1.7-9.73-7.07,11.13-12.72,16.37C196.59,188.63,193.37,186.35,193.37,189.2Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.26,
    y: 134.91,
    width: 60.5,
    height: 80.67,
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.8,
    y: 142.3,
    width: 49.41,
    height: 65.88,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.8,
    y: 142.3,
    width: 49.41,
    height: 65.88,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 181.97,
    width: 51.43,
    height: 68.57,
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.42,
    y: 188.25,
    width: 42,
    height: 56,
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.42,
    y: 188.25,
    width: 42,
    height: 56,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.68,337.65H427.21V134.79H300.68Zm66-48.78h55.53V284H366.7V238.68h55.53v-4.92H366.7V189.43h55.53v-4.92H366.7v-44.8h55.89v193H366.7ZM305.3,139.71h56.78v44.8H305.3Zm0,49.72h56.78v44.33H305.3Zm0,49.25h56.78V284H305.3Zm0,50.19h56.78v43.86H305.3Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.78,130.14a63.51,63.51,0,0,0-126.49,0l-.3,3.32H427.08Zm-120-2.76A57,57,0,0,1,321.13,97l35.68,30.35ZM359.88,122,325.49,92.75A57.25,57.25,0,0,1,359.88,78.6ZM366,78.53a57.28,57.28,0,0,1,33,12l-33,31Zm2.69,48.85,34.91-32.8a57.1,57.1,0,0,1,16.77,32.8Z",
    style: {
      fill: "#b5b5b5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.91,198.31s-19.17,1.13-29.42.94-17.65-2.65-20.3,1.9-3,2.66-7.41,10.82-45.11,45.48-45.95,51.36c-1.33,9.28,8.28,15.91,13.59,17.24s34.15-27.52,34.15-27.52-2.93,47-3.87,66.34-1.52,76.11-1.52,76.11h98.31s-1.9-45.93-1.71-55.23,11-55,11-55-.76,18,1.71,25.24,18.86,23.91,28.35,20.49,4.67-17.83,3.53-27.89-1.14-39.1-1.14-58.27,1.14-23-5.5-25.24-19.55-4.93-29.42-8.73-25.24-8.16-27.9-9.11S253.91,198.31,253.91,198.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.77,
    y1: 395.5,
    x2: 424.23,
    y2: 395.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.79,192.42s-6.26-.38-11.57,5.7-18,26.95-19.93,29.6,1.71,1.33,5.31.95,14.43-1.9,16.89-.95,12.72,2.09,16.9,6.65,13.47,14.8,14.8,12.14,4.55-14.8,6.07-23,2.66-16.32-3.6-24.49S259.79,192.42,259.79,192.42Z",
    style: {
      fill: "#e5c15c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.66,183.31A55.71,55.71,0,0,1,252,206.09c-6.45,12.14-3.41,35.11-.19,34S274.6,226,277.26,218.61s2.08-18.41,6.83-30.17S291.87,170,291.87,170,263.59,182.93,258.66,183.31Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.66,183.31a49.63,49.63,0,0,1-2.37,12.49,27,27,0,0,0,8.63,1.07c10.28,0,11.34-1.77,11.34-1.77s-2.13,15.24-4.61,22.68c-1.43,4.31-3.46,9.09-4.92,12.36,4.9-3.93,9.35-8.26,10.53-11.53,2.65-7.4,2.08-18.41,6.83-30.17S291.87,170,291.87,170,263.59,182.93,258.66,183.31Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M258.66,183.31A55.71,55.71,0,0,1,252,206.09c-6.45,12.14-3.41,35.11-.19,34S274.6,226,277.26,218.61s2.08-18.41,6.83-30.17S291.87,170,291.87,170,263.59,182.93,258.66,183.31Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,101.89a48.37,48.37,0,0,0-16.51,18.6c-6.07,12.34-5.69,28.66-5.69,28.66s.57,18.22-.38,25.43,8,12.34,12.14,12.53,17.08-8.35,23.16-10.82,7.78-2.85,13.66-8.73,15.95-23.73,16.52-33.78S312.75,112,304,104.93,283.52,95.63,271,101.89Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.3,185.87a12,12,0,0,0,4.25,1.24c4.18.19,17.08-8.35,23.16-10.82s7.78-2.85,13.66-8.73,15.95-23.73,16.52-33.78A46.37,46.37,0,0,0,312,116.94a27.75,27.75,0,0,0-12,8.69c-7.09,8.86,0,16-6,25.52S278.39,166,271.3,173.48,265.91,185.68,256.3,185.87Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271,101.89a48.37,48.37,0,0,0-16.51,18.6c-6.07,12.34-5.69,28.66-5.69,28.66s.57,18.22-.38,25.43,8,12.34,12.14,12.53,17.08-8.35,23.16-10.82,7.78-2.85,13.66-8.73,15.95-23.73,16.52-33.78S312.75,112,304,104.93,283.52,95.63,271,101.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.59,143.93s-2.66,1.33-2.66,2.85,1.9,1.89,1.9,1.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.92,144.5s-2.66,3-1.33,4.93,5.31.57,5.31.57-.19.95,2.09,1.14,3.61-2.66,2.28-4.55l-1.33-1.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.87,134.17c-.46,1.37-1.36,2.31-2,2.09s-.82-1.51-.37-2.88,1.35-2.31,2-2.09S267.32,132.8,266.87,134.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.2,131.78a2.84,2.84,0,0,0-3.8-1.52c-2.66,1.14-4,7.79-1.14,9.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.81,138.72c-.46,1.38-1.36,2.31-2,2.1s-.82-1.51-.37-2.88,1.36-2.31,2-2.09S283.26,137.35,282.81,138.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.14,136.34a2.83,2.83,0,0,0-3.8-1.52c-2.65,1.14-4,7.78-1.14,9.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,161.3c-1.14-.57-6.08-3.61-5.89-5.51s2.09-4.55,4-2.85,6.83,5.32,6.83,5.32,2.85,3.42,8.16,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,125.61s2.46-4.74,5.88-5.12,5.12,3.42,5.12,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.2,128.08s3.42,4.18,11,4.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.89,133.78c.56-10.06-1.14-21.83-9.87-28.85s-20.5-9.3-33-3c0,0-.92.55-2.36,1.64a23,23,0,0,0,15.84,8.8c11.76,1.33,15.56-1,19,1.52s4.36,9.3,1.89,11.57-8.35,2.09-8.73,5.51,5.51,11.58,4.75,14.23-2.28,4.37-1.14,5.51,4.37-.38,5.12-.76.36,4.22-1.86,9.57C308.47,151.59,313.49,140.79,313.89,133.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.94,154.65s4.75-6.26,8.16-6.26,5.13,5.5,3.23,10.63-5.31,7.78-9.49,8.16-4.55-1.71-4.17-3",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.67,269.48s5.31,13.47,9.11,18,14,11.95,22.58,17.65,10.25,18.41,8.92,23.15-5.31,8.54-14.23,6.08-16.14-13.1-23.54-24.11-12.33-19.17-12.9-19.74S295.67,269.48,295.67,269.48Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.28,328.31c1.33-4.74-.38-17.46-8.92-23.15s-18.79-13.1-22.58-17.65-9.11-18-9.11-18S285,290,285.61,290.54s5.5,8.73,12.9,19.74l.26.39,5.14-7.83s27.64,21.27,28.35,26.23a20.53,20.53,0,0,1,0,4.83A9.1,9.1,0,0,0,336.28,328.31Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.67,269.48s5.31,13.47,9.11,18,14,11.95,22.58,17.65,10.25,18.41,8.92,23.15-5.31,8.54-14.23,6.08-16.14-13.1-23.54-24.11-12.33-19.17-12.9-19.74S295.67,269.48,295.67,269.48Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.36,416s4.95,1.81,15.19-2.17c14.59-5.66,37.86-24.83,37.86-24.83a95.55,95.55,0,0,1-34,0c-18.81-3.38-28.93-8.44-28.93-8.44L271.7,408.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.36,416s4.95,1.81,15.19-2.17c14.59-5.66,37.86-24.83,37.86-24.83a95.55,95.55,0,0,1-34,0c-18.81-3.38-28.93-8.44-28.93-8.44L271.7,408.79Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.36,416s4.95,1.81,15.19-2.17c14.59-5.66,37.86-24.83,37.86-24.83a95.55,95.55,0,0,1-34,0c-18.81-3.38-28.93-8.44-28.93-8.44L271.7,408.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.36,416s4.95,1.81,15.19-2.17c14.59-5.66,37.86-24.83,37.86-24.83a95.55,95.55,0,0,1-34,0c-18.81-3.38-28.93-8.44-28.93-8.44L271.7,408.79Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.62,
    y1: 405.88,
    x2: 312.7,
    y2: 412.27,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.98,
    y1: 408.94,
    x2: 280.18,
    y2: 401.99,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 321.87,
    y1: 405.6,
    x2: 289.35,
    y2: 399.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.43,
    y1: 401.43,
    x2: 296.58,
    y2: 395.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 329.38,
    y1: 397.82,
    x2: 300.19,
    y2: 392.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.76,365.87s7.9-1.27,3.56,10.55-18.51,22.24-20.2,30.68.24,8.92.24,8.92l-24.59-5.3s1.93-18.33,15.43-32.31S317.76,365.87,317.76,365.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.76,365.87s7.9-1.27,3.56,10.55-18.51,22.24-20.2,30.68.24,8.92.24,8.92l-24.59-5.3s1.93-18.33,15.43-32.31S317.76,365.87,317.76,365.87Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.76,365.87s7.9-1.27,3.56,10.55-18.51,22.24-20.2,30.68.24,8.92.24,8.92l-24.59-5.3s1.93-18.33,15.43-32.31S317.76,365.87,317.76,365.87Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.77,424s4.1-1,8.2-7,13.26-25.08,20.74-35.21,19.05-15.91,19.05-15.91l-58.6-6.51s-23.87,26.76-32.07,36.17-9.16,18.08-3.37,20.25,24.11,4.34,28.93,5.07S265.67,424.7,269.77,424Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.77,424s4.1-1,8.2-7,13.26-25.08,20.74-35.21,19.05-15.91,19.05-15.91l-58.6-6.51s-23.87,26.76-32.07,36.17-9.16,18.08-3.37,20.25,24.11,4.34,28.93,5.07S265.67,424.7,269.77,424Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.77,424s4.1-1,8.2-7,13.26-25.08,20.74-35.21,19.05-15.91,19.05-15.91l-58.6-6.51s-23.87,26.76-32.07,36.17-9.16,18.08-3.37,20.25,24.11,4.34,28.93,5.07S265.67,424.7,269.77,424Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.77,424s4.1-1,8.2-7,13.26-25.08,20.74-35.21,19.05-15.91,19.05-15.91l-58.6-6.51s-23.87,26.76-32.07,36.17-9.16,18.08-3.37,20.25,24.11,4.34,28.93,5.07S265.67,424.7,269.77,424Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.4,
    y1: 415.7,
    x2: 220.72,
    y2: 404.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.72,
    y1: 409.07,
    x2: 224.03,
    y2: 397.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.87,
    y1: 401.6,
    x2: 228.18,
    y2: 390.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 285.44,
    y1: 392.47,
    x2: 232.75,
    y2: 381.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.41,
    y1: 383.34,
    x2: 237.73,
    y2: 372.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.56,
    y1: 375.88,
    x2: 241.87,
    y2: 364.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.79,
    y1: 370.07,
    x2: 248.1,
    y2: 358.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.38,356s4.82,0,2.17,7.72-18.33,28-23.39,41.71S269.77,424,269.77,424s-1.93,2.89-30.14-3.13-46.29-6.76-48-11.58,9.4-17.84,13.5-28.21,14.47-34.72,14.47-34.72,41,8,49.67,8.68S287.38,356,287.38,356Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.38,356s-9.41-.24-18.09-1-49.67-8.68-49.67-8.68-10.37,24.35-14.47,34.72a78.69,78.69,0,0,1-5.79,11l66,15.91c.22-.82.49-1.67.82-2.56,5.06-13.74,20.73-34,23.39-41.71S287.38,356,287.38,356Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.38,356s4.82,0,2.17,7.72-18.33,28-23.39,41.71S269.77,424,269.77,424s-1.93,2.89-30.14-3.13-46.29-6.76-48-11.58,9.4-17.84,13.5-28.21,14.47-34.72,14.47-34.72,41,8,49.67,8.68S287.38,356,287.38,356Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,386.6s0,1.93,7.24-6.75S287.38,356,287.38,356l-74.51-16.15S191.65,361.77,189,365.14s-4.59,4.34,2.41,7.48,42,7,49.43,8.92S256.75,386.6,256.75,386.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.75,386.6s0,1.93,7.24-6.75S287.38,356,287.38,356l-74.51-16.15S191.65,361.77,189,365.14s-4.59,4.34,2.41,7.48,42,7,49.43,8.92S256.75,386.6,256.75,386.6Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,386.6s0,1.93,7.24-6.75S287.38,356,287.38,356l-74.51-16.15S191.65,361.77,189,365.14s-4.59,4.34,2.41,7.48,42,7,49.43,8.92S256.75,386.6,256.75,386.6Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,386.6s0,1.93,7.24-6.75S287.38,356,287.38,356l-74.51-16.15S191.65,361.77,189,365.14s-4.59,4.34,2.41,7.48,42,7,49.43,8.92S256.75,386.6,256.75,386.6Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.39,378.92s-45-5.28-57.54-7.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.28,371.69s-26.69-2.78-37.81-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.12,364.18s-32.8-5.83-41.14-8.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.4,
    y1: 358.35,
    x2: 238.2,
    y2: 349.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263s-1.66,5.43-4.07,23.52-6,38.82-10.85,54.25-14.23,37.86-14.95,40.75a5.94,5.94,0,0,0,1.2,5.06s-9.4-1.44-35.93-4.34-52.56-15.91-51.84-17.6,18.09-18.81,28-41,25.32-77.89,25.32-77.89,31.35,14.71,40.75,15.68S285.42,263,285.42,263Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.35,286.54c2.41-18.09,4.07-23.52,4.07-23.52s-13-.6-22.4-1.56-40.75-15.68-40.75-15.68-11.05,39.89-20.44,65.6L273,332.1A405.61,405.61,0,0,0,281.35,286.54Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263s-1.66,5.43-4.07,23.52-6,38.82-10.85,54.25-14.23,37.86-14.95,40.75a5.94,5.94,0,0,0,1.2,5.06s-9.4-1.44-35.93-4.34-52.56-15.91-51.84-17.6,18.09-18.81,28-41,25.32-77.89,25.32-77.89,31.35,14.71,40.75,15.68S285.42,263,285.42,263Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.68,252.21s4.74,1.13,6.07,8.54,1.14,25.81.57,28.09S282,293.2,275.17,294s-3.23-1.71-.19-12.53,6.26-18.79,7.78-21.06S287.5,249.93,291.68,252.21Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.54,260.67s1.25,26.48,1.77,29.41-17.37,4.26-17.37,4.26l11-30.84",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.93,300s-6.45,4.56-8.73,5.7-14.42-3.8-14.8-5.51,2.09-1.33,5.5-1,9.3,1.33,11.77.38S287.5,297.76,286.93,300Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.29,292.06s-2.09,5.7-4.75,7.4-13.47,3.42-18.22,3-8.73-3.42-7.59-5.12-.19-.76,6.26-1.71,14.43-1.52,17.84-2.66A19,19,0,0,1,295.29,292.06Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.85,280.86s-7.21,3.8-13.09,6.46a60.08,60.08,0,0,1-5.9,2.19,62.1,62.1,0,0,1-7.2.46c-4.17,0-6.64-.37-6.64,1.33,0,2.6,4.55,4,6.48,4.53,6.71,1.92,14.62-.43,21.38-1.54A14.15,14.15,0,0,0,295.1,293c3.51-1.71,4.17-5.88,3.6-8.35l-.23-.3",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263s-4.37,12.34-9.3,27.52a277.24,277.24,0,0,0-7.79,30.37s-3.41-1.9-28.84-10.63-57.32-19.36-57.32-19.36,23.91-28.09,29-41.56,7.78-11,19.55-6.45,28.09,12.9,37.57,13.85S285.42,261.13,285.42,263Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-10--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263s-4.37,12.34-9.3,27.52a277.24,277.24,0,0,0-7.79,30.37s-3.41-1.9-28.84-10.63-57.32-19.36-57.32-19.36,23.91-28.09,29-41.56,7.78-11,19.55-6.45,28.09,12.9,37.57,13.85S285.42,261.13,285.42,263Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263s-4.37,12.34-9.3,27.52a277.24,277.24,0,0,0-7.79,30.37s-3.41-1.9-28.84-10.63-57.32-19.36-57.32-19.36,23.91-28.09,29-41.56,7.78-11,19.55-6.45,28.09,12.9,37.57,13.85S285.42,261.13,285.42,263Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.42,263s-4.37,12.34-9.3,27.52a277.24,277.24,0,0,0-7.79,30.37s-3.41-1.9-28.84-10.63-57.32-19.36-57.32-19.36,23.91-28.09,29-41.56,7.78-11,19.55-6.45,28.09,12.9,37.57,13.85S285.42,261.13,285.42,263Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.83,
    y1: 303.31,
    x2: 203.18,
    y2: 281.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.5,
    y1: 295.83,
    x2: 208.18,
    y2: 274.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.12,
    y1: 288.3,
    x2: 212.63,
    y2: 267.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.34,
    y1: 279.13,
    x2: 218.75,
    y2: 260.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.01,
    y1: 270.51,
    x2: 224.3,
    y2: 252.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 199.84,
    cy: 280.38,
    rx: 2.5,
    ry: 1.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.12,
    cy: 273.71,
    rx: 2.5,
    ry: 1.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.29,
    cy: 267.45,
    rx: 2.5,
    ry: 1.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.74,
    cy: 258.83,
    rx: 2.5,
    ry: 1.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.08,250.5c0-1-1.12-1.81-2.5-1.81s-2.5.81-2.5,1.81,1.12,1.8,2.5,1.8S222.08,251.49,222.08,250.5Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.92,258.09s-5.88,10.25-9.68,11.77-14.8-.19-14-2.66,6.26-3.23,9.87-8,6.83-11,10.24-10.06,5.89,4.93,6.08,6.26",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.37,189.2s1.14,19.35,1.14,20.11-31.32,33.41-38.53,41-7.4,13.85-5.7,18.6,7.6,11.58,12.91,12.33,11.2-4.55,16.51-16.32,24.3-47.26,26.38-51.05,7-7.21,7-7.21,5.12-2.66,7.4-6.46,6.64-11.38,11.38-15,7-4.56,4.94-5.69-8.73,1.32-10.63,2.65-6.07,4.75-6.07,4.75-3.61-5.32-3.8-9.87.95-11.06-1.7-9.73-7.07,11.13-12.72,16.37C196.59,188.63,193.37,186.35,193.37,189.2Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-11--inject-41)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.83,179.52c-2.09-1.14-8.73,1.32-10.63,2.65s-6.07,4.75-6.07,4.75-3.61-5.32-3.8-9.87.95-11.06-1.7-9.73-7.07,11.13-12.72,16.37a14,14,0,0,1-5.15,3.2l-.95,4s3.9,2.49,3.9,5.68,5,4.25,5.31,7.44-2.12,6.73-3.9,8.86-30.48,51.74-37.92,57.77c-3.11,2.51-7.2,2.74-10.91,2.16,2.62,3.95,6.92,7.93,10.9,8.49,5.31.76,11.2-4.55,16.51-16.32s24.3-47.26,26.38-51.05,7-7.21,7-7.21,5.12-2.66,7.4-6.46,6.64-11.38,11.38-15S238.92,180.65,236.83,179.52Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.37,189.2s1.14,19.35,1.14,20.11-31.32,33.41-38.53,41-7.4,13.85-5.7,18.6,7.6,11.58,12.91,12.33,11.2-4.55,16.51-16.32,24.3-47.26,26.38-51.05,7-7.21,7-7.21,5.12-2.66,7.4-6.46,6.64-11.38,11.38-15,7-4.56,4.94-5.69-8.73,1.32-10.63,2.65-6.07,4.75-6.07,4.75-3.61-5.32-3.8-9.87.95-11.06-1.7-9.73-7.07,11.13-12.72,16.37C196.59,188.63,193.37,186.35,193.37,189.2Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82,168.32l.09.15a2.19,2.19,0,0,1-.85,3l-36.08,20L208,193l4.77-5.49,36.08-20A2.19,2.19,0,0,1,251.82,168.32Z",
    style: {
      fill: "#e5c15c",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 191.47 215.24 191.32 213.02 187.35 212.76 187.49 208 192.98 214.98 191.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.34,173.53l3.72-2.08a2.19,2.19,0,0,0,.85-3l-.09-.15a2.19,2.19,0,0,0-3-.85l-3.72,2.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.59,
    y: 169.54,
    width: 2.28,
    height: 4.56,
    transform: "translate(-52.58 141.57) rotate(-29.17)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208 192.98 211.29 192.26 210.24 190.39 208 192.98",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.91,193.75s-.57,4.56-4.18,4.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.15,171s6.64,10.63,8.92,12.72,5.12,1.71,5.69-.19-3.22-5.88-4.74-11-2.09-6.64-5.13-5.88S212.34,169.13,212.15,171Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.78,184.64s-11.95-6.07-14.61-9.11-5.69.95-6.26,3,8.73,5.88,13.09,7.4,7,2.09,8.35.57S222.78,184.64,222.78,184.64Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67,180.27s-4,1.33-4.75,3,1.33,2.85,5.13,5.13,9.87,3,11.38,2.27,1.71-2.27-.38-3S204.38,181.41,202.67,180.27Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.25,186.16s-4.36-1.14-5.69,1.33.19,4,4.74,5.31,11.39,2.28,11.58-.19-3.61-2.85-6.83-4.17S199.25,186.16,199.25,186.16Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.47,347.58s-2.18-7.1-8.56-9.65c-4.43-1.78-9.52-1.31-14.11-.51-8.55,1.48-16,4.88-24.12,7.79,0,0,3.46-1.28,17.66,5.64,5.23,2.55,11.21,4.53,17.19,4.39C85.34,355.14,92.7,353.77,92.47,347.58Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.24,326.72s0-7.43-5.4-11.71c-3.73-3-8.75-4-13.37-4.57-8.62-1-16.74.05-25.34.49,0,0,3.68-.22,15.28,10.51,4.27,3.95,9.42,7.57,15.19,9.17C84.23,331.89,91.67,332.71,93.24,326.72Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92,354.3s-5.79-4.65-5.81-11.51c0-4.77,2.29-9.34,4.73-13.31,4.53-7.4,10.44-13.08,16.13-19.54,0,0-2.46,2.74-1.26,18.49.44,5.8.07,12.09-2.26,17.6C117.58,350.46,113.59,356.8,107.92,354.3Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.44,365.71s-.82-7.39,4-12.26c3.36-3.38,8.22-5,12.75-6.08,8.44-2,16.63-1.88,25.23-2.44,0,0-3.68.21-14,12.2-3.79,4.42-8.49,8.61-14,10.87C138,369.81,130.69,371.48,128.44,365.71Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09,339.39s-7.36-1-10.9-6.89c-2.46-4.09-2.82-9.19-2.77-13.85.09-8.68,2.24-16.59,3.8-25,0,0-.7,3.61,8.42,16.51,3.35,4.76,6.27,10.34,7.1,16.26C133.41,331.13,133.24,338.62,127.09,339.39Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.27,326.17s5.3,5.22,12.12,4.43c4.73-.54,9-3.37,12.66-6.25,6.82-5.36,11.77-11.9,17.53-18.3,0,0-2.44,2.76-18.22,3.41-5.82.24-12,1.34-17.22,4.3C151,316.13,145.13,320.83,148.27,326.17Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.14,321s7.4.74,12.22-4.14c3.35-3.39,4.9-8.27,5.95-12.81,1.95-8.46,1.71-16.65,2.18-25.25,0,0-.17,3.68-12.06,14.08-4.38,3.84-8.52,8.58-10.72,14.14C138,311.51,136.35,318.83,142.14,321Z",
    style: {
      fill: "#e5c15c"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "115.76 392.96 103 361.56 88.28 325.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "118.7 387.56 131.46 343.89 145.19 316.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.61,
    y1: 370.39,
    x2: 136.36,
    y2: 363.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.46,
    y1: 343.89,
    x2: 125.08,
    y2: 329.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.44,
    y1: 329.73,
    x2: 155.01,
    y2: 322.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.45,
    y1: 367.44,
    x2: 110.85,
    y2: 345.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.3,
    y1: 351.03,
    x2: 85.83,
    y2: 344.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.49 408.66 105.48 408.66 100.55 382.65 133.42 382.65 128.49 408.66",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.dde1ffc972149191f898c6e69d8f77dd.svg";
export { ForwardRef as ReactComponent };